<template>
  <div class="container mt40 retail-details">
    <div class="common-detail-content">
      <!-- 上半部 -->
      <div class="content-box">
        <div class="banner-box">
          <div class="left">
            <div class="banner">
              <el-carousel ref="carousel" :interval="5000" arrow="always" height="356px" :initial-index="bannerIdx">
                <el-carousel-item v-for="(item,index) in banners" :key="index">
                  <img :style="{width: '100%', height: '100%'}" :src="item" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="banner-label">
              <div :class="['banner-label-item', bannerActiveIdx == 0 ? 'active' : '']" @click="bannerChange(0)">全部图片({{info.bannerTotalNum || 0}})</div>
              <template v-if="info.bannerList.length > 0">
                <div :class="['banner-label-item', bannerActiveIdx === index + 1 ? 'active' : '']" v-for="(item, index) in info.bannerList" :key="index" @click="bannerChange(index + 1)">{{item.title}}({{item.imgList.length}})</div>
              </template>
            </div>
          </div>

          <div class="right">
            <div class="title">
              <div class="title-name">{{info.name}}</div>
            </div>
            <div class="score">
              <div class="score-start">
                <div class="star-box" v-for="(star, starIdx) in 5" :key="starIdx">
                  <div class="star-icon1"></div>
                  <div :style="{width: info.avgReviewScore <= star ? '0':(17 * (info.avgReviewScore - star) + 'px')}" class="star-icon2"></div>
                </div>
              </div>
              <div class="score-grade">{{info.avgReviewScore == null ? '暂无评' : info.avgReviewScore}}分</div>
              <div class="score-number">{{info.reviewTimes || 0}}</div>
              <div class="score-text">人评论</div>
            </div>
            <div class="contactway">
              <div class="contactway-item">
                <div class="label">所在地址:</div>
                <div class="text">
                  {{info.addressDetails}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">营业时间:</div>
                <div class="text">
                  {{info.openingTime}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">联系方式:</div>
                <div class="text">
                  {{info.phone ? info.phone : '暂无联系方式'}}
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">商店简介:</div>
                <div class="text">
                  <p :class="{'show-all': showAll===true}">{{info.synopsis}}</p>
                  <span class="btn" @click="handleShow">{{showAll?'点击收起':'查看全部'}}</span>
                </div>
              </div>
              <div class="contactway-item">
                <div class="label">人均消费:</div>
                <div class="price">
                  ￥{{info.consumptionPerPerson || 0}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flat-pattern">
          <div class="left-arrows" :class="{disabled: banners.length <= 6 || moveLeft === 0}" @click="handleBannerPrev"></div>
          <div class="img-list">
            <div class="img-box" :style="{left: -moveLeft + 'px'}">
              <div class="img-item" v-for="(item,index) in banners" :key="index">
                <img :src="item" alt="" @click="bannerIdxSel(index)">
              </div>
            </div>
          </div>
          <div class="right-arrows" :class="{disabled: banners.length <= 6 || moveLeft === (banners.length - 6) * imgHeight}" @click="handleBannerNext"></div>
        </div>
      </div>

      <!-- 中间 -->
      <div class="content-area">
        <div class="tabs">
          <span :class="isSupportDelivery ? 'active' : ''" @click="handleTab(true)">快递商品</span>
          <span :class="!isSupportDelivery ? 'active' : ''" @click="handleTab(false)">到店自取</span>
        </div>

        <div class="body-list">
          <template v-if="proList.length > 0">
            <div class="body-item" v-for="item in proList" :key="item.goodsId">
              <div class="left-img"><img :src="item.mainPic || require('../../assets/images/default_img.jpg')" alt=""></div>
              <div class="left-right">
                <div class="right-title">{{item.name}}</div>
                <div class="right-des">
                  <span class="label">产品详情</span>
                  <span>{{item.goodsDescription || '暂无'}}</span>
                </div>
                <div class="price-freight">
                  <div class="price">
                    <span class="label">价格</span>
                    <span class="cont">抢购价 ￥
                      <em v-if="item.skuObj">{{item.skuObj.goodsPrice}}</em>
                      <em v-if="item.skuObj && item.skuObj.marketPrice != null" class="market-price">￥{{item.skuObj.marketPrice}}</em>
                    </span>
                  </div>
                  <!-- <div v-if="isSupportDelivery" class="freight">
                    <span class="label">运费</span>
                    <span>广东</span> <span class="away">至</span> <span>深圳</span>
                    <span class="const">快递费 10.00元</span>
                  </div> -->
                  <div v-if="!isSupportDelivery" class="freight">
                    <span class="label">运费</span>
                    <span>无运费(到店自取商品)</span>
                  </div>
                </div>
                <div class="spec-info">
                  <div v-for="(spec, ind) in item.specificationItems" :key="ind" class="specs">
                    <span class="label">选则{{spec.name}}</span>
                    <span v-for="(ent, eind) in spec.entries" :key="eind" class="spec-item" :class="ent.selected ? 'active' : ent.disabled ? 'disabled' : ''" @click.stop="handleSpec(ind, ent, null, item)">{{ent.value}}</span>
                  </div>
                </div>
                <div class="item-bottom">
                  <el-input-number class="num" v-model="item.quantity" controls-position="right" :min="1" :precision="0"></el-input-number>
                  <el-button class="cart-btn" :disabled="item.quantity == null || item.quantity < 1" @click="handleAddtoCart(item)">加入购物车</el-button>
                  <el-button class="buy-btn" :disabled="item.quantity == null || item.quantity < 1" @click="handleToBuy(item)">立即购买</el-button>
                </div>
              </div>
            </div>
          </template>
          <div v-else class="no-data">暂无数据</div>
        </div>
      </div>

      <!-- 点评 -->
      <div class="content-box remark">
        <div class="information">
          <div class="titile">网友点评({{totalCount}})</div>
          <div class="comment-box">
            <div class="comment-list" v-for="item in commentList" :key="item.id">
              <div class="flex floor">
                <img :src="item.avatarUrl"/>
                <div class="com-name">
                  <div class="name">{{item.crtName}}</div>
                  <el-rate v-model="item.score" disabled show-score text-color="#FF0000" :score-template="item.score+'分'"/>
                </div>
                <div class="com-date">{{item.crtTime}}</div>
              </div>
              <div class="com-content">
                {{item.content}}
                <div class="img-comm">
                    <img v-for="(imgs,index) in item.pictures" :key="index" :src="imgs.url"/>
                </div>
                <div class="reply" v-if="item.replyContent">
                  <span class="lare">商家回复:</span>
                  {{item.replyContent}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagination-self">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="prev, pager, next"
            :total="totalCount"
            @current-change="handleCurrentChangeCommen"
            :page-size="10"
            >
          </el-pagination>
        </div>
      </div>

    </div>
    <!-- 加购成功弹窗 -->
    <div class="shadow" :class="showpop ? '' : 'hide'">
      <div class="container">
        <div class="close"><img src="../../assets/images/close.png" alt="" @click="showpop = false"></div>
        <div class="title">添加成功</div>
        <div class="cart-pic">
          <img src="../../assets/images/cart-img.png" alt="">
        </div>
        <div class="text">商品已经成功添加至购物车！</div>
        <div class="btns">
          <el-button @click="showpop = false">继续购物</el-button>
          <el-button @click="handleToCart">去购物车结算</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadInfo, goodsList, loadCommentList, addToCart } from '@/api/retail/retailDetail'
import { richTextWrap } from '@/common/js/utils'
import { queryDetailMixin } from '@/mixins/queryDetailMixin'
import { config } from '@/constant/config'
export default {
  mixins: [queryDetailMixin],
  data () {
    return {
      moduleType: 'RETAIL',
      grade: 3.5,
      navList: ['快递商品', '到店自取'],
      reservationNotesVisible: false,
      commentList: [],
      showAll: false,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      limit: 10,
      bedTypeList: [],
      isSupportDelivery: true,
      showpop: false
    }
  },
  ceated () {
    this.loadCommentList()
  },
  methods: {
    // 点击产品选择规格
    handleChooseSpec (obj) {
      const info = JSON.parse(JSON.stringify(obj))
      const defaultSku = info.skus.find(item => item.isDefault) // 默认选中sku
      let target = {}
      let targetInd = 0
      // 整理出默认选中sku值
      if (defaultSku && defaultSku.specificationValues) {
        defaultSku.specificationValues.forEach(item => {
          for (let i = 0; i < info.specificationItems.length; i++) {
            for (let j = 0; j < info.specificationItems[i].entries.length; j++) {
              if (info.specificationItems[i].entries[j].id === item.id) {
                // 对应默认选中sku值
                info.specificationItems[i].entries[j].selected = true
                target = info.specificationItems[i].entries[j]
                targetInd = i
                break
              }
            }
          }
        })
      }
      info.qty = 1
      let specFormData = info
      if (defaultSku && defaultSku.specificationValues) {
        specFormData = this.handleSpec(targetInd, target, () => { specFormData.originSkuObj = specFormData.skuObj }, specFormData)
        return Object.assign({}, specFormData)
      } else {
        specFormData.skuObj = defaultSku || {}
        return specFormData
      }
    },
    // 规格选择
    handleSpec (index, obj, callBack, specFormData) {
      if (obj.disabled) return
      specFormData.specificationItems[index].entries.forEach(item => {
        // 去除对应规格行已选中状态
        item.selected = false
      })
      obj.selected = true // 当前选中规格
      const selectedSpecIds = [obj.id]
      let defaultSelectSpecInd = null // 原本已选中规格行下标
      specFormData.specificationItems.forEach((item, ind) => {
        if (ind !== index) {
          const selectedObj = item.entries.find(subitem => subitem.selected)
          if (selectedObj) {
            selectedSpecIds.push(selectedObj.id)
            defaultSelectSpecInd = ind
          }
        }
      })
      if (specFormData.specificationItems.length > 1) {
        // 不止一种规格，后台限定最多添加3种规格
        // 至少选中n-1个规则后才能判断是否可售，在skuList 中找不到对应价格为不可售
        if (specFormData.specificationItems.length > 2) {
          // 3种规格
          specFormData.specificationItems.forEach((item, ind) => {
            // 找出未选中规格
            if (ind !== index && ind !== defaultSelectSpecInd) {
              item.entries.forEach(ent => {
                // 一一找出未选中规格对应sku判断是否可售
                // selectedSpecIds.push(ent.id)
                if (selectedSpecIds.length === specFormData.specificationItems.length) {
                  const target = this.mapSkuObj(selectedSpecIds, specFormData)
                  if (!target) {
                    ent.selected = false
                    this.$set(ent, 'disabled', true)
                  } else {
                    ent.disabled = false
                  }
                }
              })
            }
          })
        } else {
          // 2种规格
          for (let i = 0; i < specFormData.specificationItems.length; i++) {
            const spec = specFormData.specificationItems[i]
            const selectedEnt = spec.entries.find(ent => ent.selected)
            if (selectedEnt) {
              specFormData.specificationItems.forEach((spec, ind) => {
                if (ind !== i) {
                  spec.entries.forEach(ent => {
                    const target = this.mapSkuObj([selectedEnt.id, ent.id], specFormData)
                    if (!target) {
                      ent.selected = false
                      this.$set(ent, 'disabled', true)
                    } else {
                      ent.disabled = false
                    }
                  })
                }
              })
              break
            }
          }
        }
      } else {
        // 只有一种规格
        specFormData.specificationItems[index].entries.forEach(ent => {
          const target = this.mapSkuObj([ent.id], specFormData)
          if (!target) {
            ent.selected = false
            this.$set(ent, 'disabled', true)
          } else {
            ent.disabled = false
          }
        })
      }
      if (selectedSpecIds.length === specFormData.specificationItems.length) {
        const target = this.mapSkuObj(selectedSpecIds, specFormData)
        if (target) {
          this.$set(specFormData, 'skuObj', target)
          if (callBack) {
            callBack()
          }
        } else {
          specFormData.skuObj = {}
        }
      } else {
        specFormData.skuObj = {}
      }
      return specFormData
    },
    // 定价sku
    mapSkuObj (selectedSpecIds, specFormData) {
      let target = null // 定价sku对象
      for (let i = 0; i < specFormData.skus.length; i++) {
        const skuObj = specFormData.skus[i]
        let inArr = 0 // 标记选中skuid在此skuObj.entries存在次数
        selectedSpecIds.forEach(item => {
          if (skuObj.specificationValues.find(obj => obj.id === item)) {
            inArr += 1
          }
        })
        if (inArr === selectedSpecIds.length) {
          // 该skuObj包含所有选中规格值，既选中sku
          if (skuObj.stock > 0) {
            target = skuObj
          }
          break
        }
      }
      return target
    },
    // 加入购物车
    handleAddtoCart (item) {
      const param = {
        goodsTargetId: item.skuObj.id,
        moduleType: this.moduleType,
        quantity: item.quantity
      }
      addToCart(param).then(res => {
        if (res.code === 0) {
          this.showpop = true
          this.$parent.$refs.topHeader.loadCartNum()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    handleToBuy (item) {
      this.$router.push({ path: 'retailOrderConfirm' })
      if (item.skuObj.specificationValues && item.skuObj.specificationValues.length > 0)item.attributes = '["' + item.skuObj.specificationValues[0].value + '"]'
      item.goodsPrice = item.skuObj.goodsPrice
      const orderInfo = {
        industryName: this.info.name,
        industryId: this.info.id,
        goodsList: [item]
      }
      localStorage.setItem('retailOrderList', JSON.stringify([orderInfo]))
    },
    // 去购物车
    handleToCart () {
      this.$router.push({ path: 'cart' })
    },
    loadInfo () {
      loadInfo(this.id).then(res => {
        if (res.code === 0) {
          const obj = res.data
          obj.reservationNotes = richTextWrap(obj.reservationNotes) || '暂无'
          this.loadIndustryOrMerchData(obj)
        }
      })
    },
    loadProducts (id) {
      const param = {
        limit: 100,
        merchId: config.MERCHID,
        orderType: 'COMPLEX_DESC',
        page: 1,
        saleStationId: config.SALESTATIONS,
        tenantId: config.TENANTID,
        isSupportDelivery: this.isSupportDelivery
      }
      goodsList(id, param).then(res => {
        this.loadList(res.data.list || [])
      })
    },
    handleCurrentChangeCommen (val) {
      this.page = val
      this.loadCommentList()
    },
    handleShow () {
      this.showAll = !this.showAll
    },
    loadCommentList () {
      const data = {
        limit: this.limit,
        page: this.page,
        merchIndustryId: this.id
      }
      loadCommentList(data).then(res => {
        if (res.code === 0) {
          this.commentList = res.data.list
          this.commentList.forEach(listItem => {
            const pictures = listItem.pictures ? JSON.parse(listItem.pictures) : []
            pictures.forEach(item => {
              if (item.index !== 1) {
                item.imgList = item.url.split(',')
                listItem.bannerList = item.imgList
              }
            })
          })
          this.totalPage = res.data.totalPage
          this.totalCount = res.data.totalCount
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.top {
  height: 166px;
  width: 100%;
}

.container {
  width: 1279px;
  overflow-x: auto;
}
.common-detail-content {
  .content-box {
    .body-list {
      .left {
        .left-right {
          .rules {
            span {
              display: inline-block;
              padding: 0 10px;
              height: 18px;
              margin-right: 12px;
              line-height: 18px;
              border: 1px solid #F0BD5D;
              border-radius: 2px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #F0BD5D;
              &:nth-of-type(2) {
                border-color: #C9ADAD;
                color: #C9ADAD;
              }
              &:nth-of-type(3) {
                color: #ADAFC9;
                border-color: #ADAFC9;
              }
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
.retail-details {
  .content-area {
    margin-bottom: 40px;
    background: #FFFFFF;
    box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
    opacity: 1;
    border-radius: 8px;
    .tabs {
      padding-left: 40px;
      height: 69px;
      line-height: 69px;
      border-bottom: 1px solid #8FA8BC;
      span {
        display: inline-block;
        margin-right: 30px;
        height: 69px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #95A3AF;
        cursor: pointer;
        &.active {
          position: relative;
          font-weight: bold;
          color: #9B232A;
          &::after {
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            content: '';
            width: 36px;
            height: 4px;
            background: #9B232A;
          }
        }
      }
    }

    .body-list {
      padding: 0 40px;
      .body-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 40px;
        padding-bottom: 30px;
        border-bottom: 1px solid #C7D3DD;
        &:last-child {
          border-bottom: none;
        }

        .left-img {
          width: 546px;
          height: 384px;
          margin-right: 40px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .left-right {
          flex: 1;
          .right-title {
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            line-height: 36px;
            color: #242B34;
          }

          .right-des {
            margin: 12px 0;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 20px;
            color: #424855;
            .label {
              margin-right: 32px;
            }
          }

          .price-freight {
            padding: 20px 0 20px 28px;
            background: #F5F5F5;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #424855;
            .price {
              margin-bottom: 12px;
              .cont {
                color: #FF0000;
                em {
                  font-style: normal;
                  font-size: 28px;
                  font-weight: bold;
                  &.market-price {
                    margin: 0 10px;
                    color: #BEBEBE;
                    font-size: 18px;
                    text-decoration: line-through;
                  }
                }
              }
            }

            .label {
              margin-right: 32px;
            }

            .freight {
              .away {
                margin: 0 16px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #9FA1B0;
              }
              .const {
                margin-left: 41px;
              }
            }
          }

          .spec-info {
            margin: 24px 0;
            .specs {
              margin-bottom: 20px;
              &:last-child {
                margin-bottom: 0;
              }
            }
            .label {
              margin-right: 32px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 20px;
              color: #424855;
            }
            .spec-item {
              margin-top: 16px;
              margin-right: 12px;
              padding: 4px 16px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #9FA1B0;
              border: 1px solid #9FA1B0;
              border-radius: 4px;
              cursor: pointer;
              &:first-child {
                margin-top: 0;
              }
              &.active {
                color: #9B232A;
                border-color: #9B232A;
              }
              &.disabled {
                color: #d8d8dc;
                border-color: #d8d8dc;
                cursor: not-allowed;
              }
            }
          }

          .item-bottom {
            .num {
              margin-right: 32px;
            }
            .cart-btn {
              width: 112px;
              height: 36px;
              padding: 0;
              background: #FC600C;
              border-radius: 4px;
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 36px;
              text-align: center;
              &.is-disabled {
                background: #babcbd;
              }
            }

            .buy-btn {
              width: 112px;
              height: 36px;
              padding: 0;
              background: #9B232A;
              border-radius: 4px;
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 36px;
              color: #FFFFFF;
              &.is-disabled {
                background: #babcbd;
              }
            }
          }
        }
      }
    }
  }
}

.retail-details {
  .shadow {
    .cart-pic {
      margin-top: 35px;
    }
    .text {
      margin-top: 10px;
      margin-bottom: 58px;
    }
  }
}
</style>
